export default __webpack_public_path__ + "static/media/growingstorm.227fe764.png";